import * as React from 'react';

function SvgInstagram(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 40 40" width="1em" {...props}>
      <path
        d="M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zm5.23-7A6.778 6.778 0 0032 26.23V14.77A6.778 6.778 0 0025.23 8H13.77A6.778 6.778 0 007 14.77v11.46A6.778 6.778 0 0013.77 33h11.46zM13.77 10.083h11.46a4.693 4.693 0 014.687 4.688v11.458a4.693 4.693 0 01-4.688 4.688H13.771a4.693 4.693 0 01-4.688-4.688V14.771a4.693 4.693 0 014.688-4.688zM19.5 26.75a6.257 6.257 0 006.25-6.25 6.257 6.257 0 00-6.25-6.25 6.257 6.257 0 00-6.25 6.25 6.257 6.257 0 006.25 6.25zm0-10.417a4.171 4.171 0 014.167 4.167 4.171 4.171 0 01-4.167 4.167 4.171 4.171 0 01-4.167-4.167 4.171 4.171 0 014.167-4.167zm6.64-1.041a1.432 1.432 0 100-2.865 1.432 1.432 0 000 2.865z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgInstagram;
